export const questions = [
  {
    id: 1,
    title: "what is the abbreviation of html?",
    answers: [
      { text: "hypertext markup language" },
      { text: "hit text and make language" },
      { text: "hyper the text of make language" },
      { text: "higher text makeup language" },
    ],
    trueAnswer: "hypertext markup language",
  },
  {
    id: 2,
    title: "How is document type initialized in HTML5?",
    answers: [
      { text: "</DOCTYPE HTML>" },
      { text: "</DOCTYPE>" },
      { text: "<!DOCTYPE HTML>" },
      { text: "</DOCTYPE html>" },
    ],
    trueAnswer: "<!DOCTYPE HTML>",
  },
  {
    id: 3,
    title:
      "Which of the following HTML Elements is used for making any text bold ?",
    answers: [
      { text: "<p>" },
      { text: "<i>" },
      { text: "<li>" },
      { text: "<b>" },
    ],
    trueAnswer: "<b>",
  },
  {
    id: 4,
    title:
      "Which of the following HTML element is used for creating an unordered list?",
    answers: [
      { text: "<ui>" },
      { text: "<i>" },
      { text: "<em>" },
      { text: "<ul>" },
    ],
    trueAnswer: "<ul>",
  },
  {
    id: 5,
    title: "How many heading tags are there in HTML5?",
    answers: [{ text: "4" }, { text: "6" }, { text: "2" }, { text: "7" }],
    trueAnswer: "6",
  },
];
